import { call911Page, immediateDangerPage, InspectQOC } from './pages'
import { commonPageSequence, employeePage, reviewPage } from '../../../pages'

export const formSchema = saveComplaint => {
  const initialPages = [
    immediateDangerPage({
      gotoPageYes: 'call_911_page',
      gotoPageNo: 'date_of_activity_page'
    }),
    call911Page()
  ]
  const finalPages = [employeePage(), reviewPage(InspectQOC)]

  return {
    title: 'Quality of Care Complaint Form',
    onSubmit: formValues => saveComplaint(formValues),
    pages: initialPages.concat(commonPageSequence(), finalPages)
  }
}
